<template>
  <div class="app-admin">
    <XAdmin ref="admin"
            enable-dialog
            :banner="banner"
            :main-padding="false"
            home-path="/dashboard"
            :default-skin="defaultSkin"
            default-size="mini"
            :menus="menus"
            :user="user"
            :beforeMenuSelect="beforeMenuSelect"
            :menu-adapter="menuAdapter"
            :tab-adapter="tabAdapter"
            :favorites="computedFavorites"
            @add-favorite="addFavorite"
            @remove-favorite="removeFavorite"
            @sort-favorite="sortFavorite"
            @skin-change="handleSkinChange"
            :menu-props="{uniqueOpened:false, defaultActive}"
            @tool-click="toolClick"
            @user-tool-click="userToolClick"
            @menu-select="handleMenuSelect">
      <template #logo>
        <img class="logo" src="../static/img/loginLogo.png" alt="">
        <div class="logo-text">共享菜园平台</div>
      </template>
    </XAdmin>
    <!--    <ModifyPassword :visible.sync="modifyPasswordVisible"></ModifyPassword>-->
<!--    <x-password-dialog :visible.sync="modifyPasswordVisible" width="30%"></x-password-dialog>-->
    <el-dialog :visible.sync="modifyPasswordVisible">
      <x-condition ref="passwordCondition" :condition-config="passwordConditionConfig"></x-condition>
      <template v-slot:footer>
        <x-button-group :button-config="passwordButtonConfig"></x-button-group>
      </template>
    </el-dialog>
<!--    <LockScreen :visible.sync="lockScreen"></LockScreen>-->
<!--    <WarningConfirm></WarningConfirm>-->
  </div>
</template>

<script>
import XAdmin from '@/component/x-admin/Admin.vue';
// import XPasswordDialog from '@/component/x-password-dialog/x-password-dialog.vue';
// import { isUrl } from '@/util/regex';
import storage, { get, save } from '@/util/storage';
import {getLoginInfo, logout} from '@/util/user';
import {logoutApi} from '@/api/account/account';
import {
  FIELD_TYPE_INPUT
} from "@/util/x-condition-constant";
import {handleError} from "@/util/componentUtil";
import request from "@/util/request2";
import {Notification} from "element-ui";
import * as appUtils from "@/util/appUtils";
import {simplePasswordReg} from '@/util/appUtils';
// import { addUserCollectMenuApi, delUserCollectMenuApi, getUserCollectMenuApi, logoutApi } from '@/api/loginApi';
// import { saveTableColumnMsg, getTableColumnMsg } from '@/api/meta/metaDataApi';
// import LockScreen from '@/component/layout/LockScreen';
// import WarningConfirm from '@/component/layout/WarningConfirm';

const SKIN_CACHE_KEY = 'SKIN_CACHE';
const FAVORITE_SORT_PARAMS = {
  name: 'nx-framework-favorites-user-sort',
  objectType: 'favoriteMenuSort'
};
export default {
  components: {
    XAdmin,
    // ModifyPassword,
    // XPasswordDialog
    // LockScreen
    // WarningConfirm
  },
  data() {
    return {
      banner: require('../assets/head-bg.png'),
      defaultSkin: get(SKIN_CACHE_KEY, {type: 'local'}) || 'blue',
      user: null,
      menus: null,
      modifyPasswordVisible: false,
      lockScreen: false,
      favorites: [],
      passwordButtonConfig: {
        align: 'center',
        list: [
          {
            name: '取消',
            type: 'default',
            plain: true,
            click: () => {this.modifyPasswordVisible = false;}
          },
          {
            name: '保存',
            click: async () => {
              try {
                await this.$refs.passwordCondition.validate();
                const res = await request({
                  url: '/api/auth/sysUser/resetPwd',
                  params: {pwd: this.passwordConditionConfig.model.pwd, oldPwd: this.passwordConditionConfig.model.oldPwd}
                });
                if (res.isFail()) {
                  Notification.error(res.msg);
                  return;
                }
                this.modifyPasswordVisible = false;
              } catch (error) {
                handleError(error);
              }
            }
          }
        ]
      },
      passwordConditionConfig: {
        model: {},
        rules: {
          oldPwd: [{required: true, trigger: 'blur', message: '请输入旧密码'}],
          // 必须包含英文加数字，大于等于6位
          pwd: [{required: true, trigger: 'blur',
            validator: (rule, value, callback) => {
              if (appUtils.isTrimEmpty(value)) {
                callback(new RuleError('请输入新密码'));
                return;
              }
              value = value.trim();
              if (!simplePasswordReg.test(value)) {
                callback(new RuleError('密码长度最少6位'));
                return;
              }
              callback();
            }
          }],
          pwd2: [{required: true, trigger: 'blur',
            validator: (rule, value, callback) => {
              if (value !== this.passwordConditionConfig.model.pwd) {
                callback(new RuleError('两次输入的密码长度不一样'));
                return;
              }
              callback();
            }
          }]
        },
        labelWidth: '120px',
        list: [
          {
            label: '旧密码',
            field: 'oldPwd',
            type: FIELD_TYPE_INPUT,
            span: 24
          },
          {
            label: '新密码',
            field: 'pwd',
            type: FIELD_TYPE_INPUT,
            span: 24
          },
          {
            label: '再次确认',
            field: 'pwd2',
            type: FIELD_TYPE_INPUT,
            span: 24
          }
        ]
      }
    };
  },
  computed: {
    menuItemMap() {
      const map = {};
      const menus = this.toFlat(this.menus || []);
      menus.forEach(n => {
        map[n.id] = n;
      });
      return map;
    },
    computedFavorites() {
      const items = [];
      const menuItemMap = this.menuItemMap;
      this.favorites.forEach(n => {
        const menu = menuItemMap[n.menuId];
        if (menu) {
          items.push({
            ...menu,
            ...n,
            favoriteId: n.id
          });
        }
      });
      return items;
    },
    defaultActive() {
      const menuItemMap = this.menuItemMap;
      const path = this.$route.path;
      const items = Object.values(menuItemMap);
      const match = items.find(n => {
        return path.startsWith(n.index);
      });
      return match?.index;
    }
  },
  methods: {
    async beforeMenuSelect(item) {
      return true;
    },
    toFlat(array = []) {
      let result = [];
      const {menuAdapter, toFlat} = this;
      array.forEach(n => {
        n = menuAdapter ? menuAdapter(n) : n;
        if (!n.children) {
          result.push(n);
        } else {
          result = result.concat(toFlat(n.children));
        }
      });
      return result;
    },
    getFavoriteIdByMenuId(menuId) {
      const favItem = this.computedFavorites.find(n => (n.menuId === menuId || n.index === menuId));
      return favItem?.id;
    },
    getMenuByIndex(index) {
      return Object.values(this.menuItemMap).find(n => {
        return n.index === index || (index.startsWith('/lowcode') && index.startsWith(n.index));
      });
    },
    menuAdapter(item) {
      return {
        ...item,
        // index: item.children ? item.id : (isUrl(item.letter) ? item.letter : `/${item.letter}`),
        index: Array.isArray(item.children) && item.children.length > 0 ? item.id : item.url,
        trigger: 'blank',
        text: item.name,
        icon: {size: 14, name: (item.children ? 'el-icon-folder' : 'el-icon-document')}
      };
    },
    tabAdapter(tab) {
      if (tab.home) return {};
      const menu = this.getMenuByIndex(tab.path);
      const isKeepAlive = !(tab.keepAlive === false || tab.noCache === true);
      return {
        ...tab,
        icon: 'el-icon-document',
        enableFavorite: !!menu,
        enableDialog: isKeepAlive,
		name: tab.path
      };
    },
    handleSkinChange(skin) {
      this.defaultSkin = skin.theme;
      save(SKIN_CACHE_KEY, skin.theme, {type: 'local'});
    },
    addFavorite(tab) {
      /*const menu = this.getMenuByIndex(tab.path);
      if (!menu) return;
      const {userId, rowid, roleId} = this.user;
      addUserCollectMenuApi({
        userId: userId,
        userRowid: rowid,
        userRoleId: roleId,
        menuId: menu.id
      }).then(res => {
        this.favorites = Object.freeze([res.data.data, ...this.favorites]);
        this.saveFavoriteSort(this.favorites);
      });*/
    },
    removeFavorite(tab) {
      /*const favoriteId = tab.favoriteId || this.getFavoriteIdByMenuId(tab.path);
      delUserCollectMenuApi({
        ids: favoriteId
      }).then(res => {
        this.favorites = Object.freeze(this.favorites.filter(n => n.id !== favoriteId));
        this.saveFavoriteSort(this.favorites);
      });*/
    },
    saveFavoriteSort(favorites) {
      /*const list = favorites.map(n => n.id);
      return saveTableColumnMsg({
        ...FAVORITE_SORT_PARAMS,
        id: this.favoriteSortId,
        objectJson: JSON.stringify(list)
      }).then(res => {
        const data = res.data.data;
        this.favoriteSortId = data?.id || '';
        return data;
      });*/
    },
    sortFavorite({oldIndex, newIndex}) {
      /*const favorites = this.favorites.slice(0);
      const oldTemp = favorites[oldIndex];
      favorites.splice(oldIndex, 1);
      favorites.splice(newIndex, 0, oldTemp);
      this.favorites = Object.freeze(favorites);
      this.saveFavoriteSort(this.favorites);*/
    },
    async fetchSortFavorites(favorites = []) {
      /*let sortIds = await getTableColumnMsg({
        ...FAVORITE_SORT_PARAMS,
        page: 1,
        pageSize: 1
      }).then(res => {
        const list = res.data.data?.list;
        if (list && list.length) {
          const {id, objectJson} = list[0];
          this.favoriteSortId = id;
          return JSON.parse(objectJson);
        }
        return [];
      });
      if (sortIds.length !== favorites.length) {
        const notExistIds = favorites.filter(n => !sortIds.includes(n.id)).map(n => n.id);
        sortIds = sortIds.concat(notExistIds);
      }
      // 无自定义排序，以当前收藏初始化排序数据保存
      if (sortIds.length === 0) {
        await this.saveFavoriteSort(favorites);
        return favorites;
      }
      return sortIds.map(id => {
        return favorites.find(n => n.id === id);
      }).filter(n => !!n);*/
    },
    logout() {
      logoutApi().then(res => {
        if (res.isSuccess()) {
          // this.$access.clear();
          logout();
          // const { subDir, systemType } = this.$access.options;
          // const path = subDir ? systemType.toLowerCase() + '/' : '';
          // window.location.href = `/#/login?systemType=${res.data.systemType}` + `${res.data.targetId ? `&targetId=${res.data.targetId}` : ''}`;
          const location = window.location;
          location.replace(location.origin + '/login');
        } else {
          this.$notify.error(res.msg); // 提示错误
        }
      });
    },
    toolClick({name}) {
      switch (name) {
        case 'lock':
          this.lockScreen = true;
          break;
        case 'exit':
          this.logout();
          break;
      }
    },
    userToolClick(command) {
      switch (command) {
        case 'password':
          this.modifyPasswordVisible = true;
          break;
        case 'logout':
          this.logout();
          break;
      }
    },
    handleMenuSelect(item) {
    }
  },
  async created() {
    const loginInfo = getLoginInfo();
    if (loginInfo) {
      const menus = loginInfo.menuTrees || [];
      const info = loginInfo.sysUser;
      this.menus = Object.freeze(menus);
      this.user = Object.freeze({
        ...info,
        avatar: info.icon
      });
    }
    // 默认设置为blue
    if (!storage.get(SKIN_CACHE_KEY)) {
      save(SKIN_CACHE_KEY, 'blue', {type: 'local'});
    }
    /*const fav = await getUserCollectMenuApi({
      userId: info.userId,
      pageSize: 10000,
      page: 1
    }).then(({data}) => {
      const list = data.data?.list || [];
      const menuItemMap = this.menuItemMap;
      // 菜单收藏有脏数据，会有不存在的菜单，需要做过滤处理
      return list.filter(n => !!menuItemMap[n.menuId]);
    });
    this.favorites = Object.freeze(await this.fetchSortFavorites(fav));*/
  },
  async mounted() {
    window.$admin = this.$refs.admin;
  }
};
</script>

<style lang="scss" scoped>
.logo {
  height: 34px;
}
.logo-text {
  padding-left: 10px;
  font-size: 17px;
  text-align: center;
  color: #2CA6D9;
}
</style>
